import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { settingsActions } from './actions';
import {
  SETTINGS_FAILURE,
  SETTINGS_REQUEST,
  SETTINGS_SUCCESS,
} from '../../constants/settings';
export type FeatureFlag = {
  name: string;
  enabled: boolean;
};
export type Settings = {
  whatsapp_users_url: string;
  whatsapp_tipsters_url: string;
  contact_email: string;
  tipster_dashboard_url: string;
  feature_flags: FeatureFlag[];
};
export type SettingsState = {
  requested: boolean;
  data: Settings | null;
  isLoading: boolean;
  error: string | null;
};
export type SettingsActions = ActionType<typeof settingsActions>;

export const settingsReducer = combineReducers<SettingsState, SettingsActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case SETTINGS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = null, action) => {
    switch (action.type) {
      case SETTINGS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case SETTINGS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case SETTINGS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
